import React, { useState } from "react";
import { Route, Redirect } from "react-router";
import { Layout } from "./components/Layout";
import { Catalog } from "./components/Home/Catalog";
import { CatalogCustomLine } from "./components/Home/CatalogCustomLine";
import {ModelContextProvider } from "./components/ModelContext";
import CssBaseline from "@mui/material/CssBaseline";

import useMediaQuery from '@mui/material/useMediaQuery';
import TagManager from 'react-gtm-module'


export const App = () => {

    //const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
    //const [light, setLight] = useState(!prefersDarkMode);

    //React.useMemo(
    //    () => setLight(!prefersDarkMode),
    //    [prefersDarkMode],
    //);

    const tagManagerArgs = {
        gtmId: 'GTM-W6FBKKJ'
    }
    TagManager.initialize(tagManagerArgs)


    return (
        <>
            <ModelContextProvider>
                <CssBaseline />
                <Layout>
                    <Route exact path="/" component={Catalog} />
                    <Route exact path="/CustomLineNavetta50" >
                        <Redirect to="/CustomLine50" />
                    </Route>
                    <Route exact path="/CustomLine50" render={(props) => <CatalogCustomLine basicModelId="N50" />} />
                    <Route exact path="/ClientApp">
                        <Redirect to="/" />
                    </Route>
                </Layout>
            </ModelContextProvider>
        </>
    );
};

export default App;
